module.exports = __webpack_public_path__ + "static/media/Save to Google Pay - German (Dark).b168e793.svg";